import { ApolloClient } from "@apollo/client";
import { ContabilidadPropietario, DatosPropietarioContabilidad } from "../../../bussines/entities/contabilidadesPropietario.entity";
import { getContabilidadPropietarioListGql, getDatosContabilidadPropietarioGql } from "../gql/ContabilidadPropietario.gql";
import { paramsGetDatosPropietarioContabilidad } from "../../../bussines/params/ContabilidadPropietario.params";


export class ContabilidadPropietarioApolloProvider {
    private apolloClient: ApolloClient<object>;

    constructor(ApolloClient: ApolloClient<object>) {
        this.apolloClient = ApolloClient;
    }

    async getContabilidadPropietarioList(): Promise<ContabilidadPropietario[]> {
        try {
            const response = await this.apolloClient.query({
                query: getContabilidadPropietarioListGql
            })
            return response.data.contabilidadPropietarioList;
        } catch (error) {
            throw error;
        }
    }

    async getDatosContabilidadPropietario(variables:paramsGetDatosPropietarioContabilidad): Promise<DatosPropietarioContabilidad> {
        try {
            const response = await this.apolloClient.query({
                variables,
                query: getDatosContabilidadPropietarioGql
            })
            return response.data.datosClienteProp[0];
        } catch (error) {
            throw error;
        }
    }
}